module.exports = __webpack_public_path__ + "img/word.21e9836f.png";